import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useArea } from '../context/AreaContext';
import { getAreaFromPath, getRedirectIfAreaPathMismatch } from '../utils/areaRoutes';
import { clearUserAreaSelection, getPendingUserArea } from '../utils/areaUserSelection';

/**
 * Mantém a área ativa alinhada à rota (ex.: /purchases/:id → Compras).
 * Não sobrescreve troca manual de área enquanto a URL ainda não mudou.
 */
const AreaRouteSync: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { area, setArea } = useArea();

  useEffect(() => {
    const pending = getPendingUserArea();
    if (pending) {
      const pathArea = getAreaFromPath(pathname);
      if (pathArea && pathArea !== pending) {
        return;
      }
      clearUserAreaSelection();
      if (area !== pending) {
        setArea(pending);
      }
      return;
    }

    const pathArea = getAreaFromPath(pathname);
    if (pathArea && pathArea !== area) {
      setArea(pathArea);
      return;
    }

    const redirect = getRedirectIfAreaPathMismatch(pathname, area);
    if (redirect) {
      navigate(redirect, { replace: true });
    }
  }, [pathname, area, setArea, navigate]);

  return null;
};

export default AreaRouteSync;
